import { render, staticRenderFns } from "./FolderRecordItemSkeleton.vue?vue&type=template&id=7fabe0e4&scoped=true"
import script from "./FolderRecordItemSkeleton.vue?vue&type=script&lang=js"
export * from "./FolderRecordItemSkeleton.vue?vue&type=script&lang=js"
import style0 from "./FolderRecordItemSkeleton.vue?vue&type=style&index=0&id=7fabe0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabe0e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSkeletonLoader})
